<template>
  <div class="aansluitingen pt-12">
    <v-container fluid black :class="[$vuetify.breakpoint.mdAndUp ? 'py-12' : 'px-0']">
      <v-container class="max-container mx-auto" :class="[$vuetify.breakpoint.mdAndUp ? '' : 'px-0']">
        <v-layout row wrap pt-12 :class="[$vuetify.breakpoint.mdAndUp ? 'px-4' : 'px-3']">
          <v-flex xs12>
            <s-card>
              <v-card-title class="px-0 white--text">
                {{ pageContent.pageSub2 }}
                <v-btn @click="maintenanceFilter = true" icon small class="ml-2"> <v-icon>filter_list</v-icon> </v-btn>
                <v-dialog v-model="addDialog"  max-width="500"  v-if="may($store.getters.permissions, 'maintenances', $store.getters.rights.RIGHT_CREATE)">
                  <template v-slot:activator="{ on }">
                    <span class="text-no-wrap">
                  
                      <v-btn v-on="on" icon small class="mx-2"> <v-icon>add</v-icon> </v-btn>
                    
                    </span>
                  </template>
                    <s-card  class="grey darken-3 stat-link" >

        <span class=" d-block headline white--text mt-4 " :class="[$vuetify.breakpoint.mdAndUp ? 'mb-0 px-3 ' : 'px-5 mb-2']">
          {{ pageContent.pageSub2 }}
        </span>

                      <div>
                        <v-card-text>
            							<v-row>
            							  <v-col cols="12" sm="6">
            								<span class="font-weight-bold d-block">Onderhoud toevoegen</span>
            							  </v-col>
            							</v-row>
            							<v-row>
            							  <v-col cols="12" sm="6">
            								<v-menu
            								  ref="menu1"
            								  v-model="menu1"
            								  :close-on-content-click="false"
            								  :return-value.sync="startDate"
            								  transition="scale-transition"
            								  offset-y
            								  min-width="290px"
            								  class="my-0"
            								>
            								  <template v-slot:activator="{ on }">
            									<v-text-field
            									  v-model="startDate"
            									  label="Onderhoud startdatum"
            									  prepend-icon="event"
            									  hide-details
            									  v-on="on"
            									></v-text-field>
            								  </template>
            								  <v-date-picker v-model="startDate" no-title scrollable :error-messages="errors.start_date">
                                <v-spacer></v-spacer>
            									<v-btn class="text-capitalize" color="primary" @click="$refs.menu1.save(startDate)">Ok</v-btn>
            								  </v-date-picker>
            								</v-menu>
            							  </v-col>
            							  <v-col cols="12" sm="6">
            								<v-menu 
            								  ref="menu2"
            								  v-model="menu2"
            								  :close-on-content-click="false"
            								  :return-value.sync="endDate"
            								  transition="scale-transition"
            								  offset-y
            								  min-width="290px"
            								  class="my-0"
            								>
            								  <template v-slot:activator="{ on }">
            									<v-text-field 
            									  v-model="endDate"
            									  label="Verwachtte einddatum"
            									  prepend-icon="event"
            									  hide-details
            									  v-on="on"
            									></v-text-field>
            								  </template>
            								  <v-date-picker v-model="endDate" no-title scrollable :error-messages="errors.end_date">
            									<v-spacer></v-spacer>
            									<v-btn class="text-capitalize" color="primary" @click="$refs.menu2.save(endDate)">OK</v-btn>
            								  </v-date-picker>
            								</v-menu>
            							  </v-col>
            							</v-row>
            							<v-row>
            							  <v-col cols="12" sm="6">
            								<v-text-field 
            								  label="Starttijd (uur)"
            								  prepend-icon="av_timer"
            								  hint="Vul een getal in tussen 0 en 23"
            								  v-model="startHour"
            								  :error-messages="errors.start_hour"
            								></v-text-field>
            							  </v-col>
            							  <v-col cols="12" sm="6">
            								<v-text-field 
            								  label="Eindtijd (uur)"
            								  prepend-icon="av_timer"
            								  hint="Vul een getal in tussen 0 en 23"
            								  v-model="endHour"
            								  :error-messages="errors.end_hour"
            								></v-text-field>
            							  </v-col>
            							</v-row>
            							<v-row>
            							  <v-col cols="12" sm="6">
            								<v-select prepend-icon="warning" :error-messages="errors.impact"  v-model="impact" :items="impacts" label="Impact"></v-select>
            							  </v-col>
            							  <v-spacer></v-spacer>
            							  <v-col cols="12" sm="6">
            								<v-combobox prepend-icon="power" :error-messages="errors.operators"  v-model="selectedOperators" :items="$store.state.operators" label="Netbeheerder(s)" multiple>
            								</v-combobox>
            							  </v-col>
            							</v-row>
                        </v-card-text>
                        <v-card-actions class="pa-3 grey darken-2">
                          <v-spacer></v-spacer>
            							<v-btn
            							  color="primary" to="" class="text-none"
            							  v-html="'Opslaan'"
            							  @click="storeMaintenance"
            							>
            							</v-btn>
                          <v-btn
                            color="primary" to="" class="text-none"
                            v-html="'Annuleren'"
                            @click="addDialog=false"
                          >
                          </v-btn>
                          <v-snackbar
                            v-model="snackbar"
                            :timeout="timeout"
                            :color="color"
                          >
                            {{ text }}
                            <v-icon class="white--text">{{ snackbar_icon }}</v-icon>
                          </v-snackbar>
                        </v-card-actions>
                      </div>
                    </s-card>
                </v-dialog>
              </v-card-title>



              <v-data-table dark
                :headers="headers"
                :items="maintenances"
                :server-items-length="maintenancesTotal"
                :options.sync="maintenanceOptions"
                :items-per-page="25"
                :loading="maintenancesLoading"
                class="elevation-0 big-headers mt-4 transparent dark-table p4-table"
                :footer-props="{ itemsPerPageOptions: [25,50,75,100], itemsPerPageText: 'Rijen per pagina' }"
                :class="[$vuetify.breakpoint.mdAndUp ? 'white-borders' : 'mobile-table']"
                dense
                loading-text="laden..."
                no-results-text="geen onderhoud beschikbaar"
                no-data-text="geen onderhoud beschikbaar"
              >
                <template v-slot:item.impact="{ item }">
                  <span class="text-no-wrap d-flex">
                    <span class="white--text no-dec mr-2"> 

                      <div class="status-indicator mr-1">
                        <div class="status-filler" :class="[item.impact === 'laag' ? 'orange' : 'red']"></div>
                      </div>
                      {{ item.impact }}</span>
                  </span>
                </template>  
              </v-data-table>



            </s-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-container>
   <filters title="Filter aanvragen" :open.sync="maintenanceFilter" :open="maintenanceFilter" :options="maintenanceFilterOptions" :values="maintenanceOptions.filters" @filter="filter"></filters>
  <v-snackbar
    v-model="snackbar"
    :timeout="timeout"
    :color="color"
  >
    {{ text }}
    <v-icon class="white--text">{{ snackbar_icon }}</v-icon>
  </v-snackbar>
  </div>
</template>

<script>

import Operator from '@/components/Operator';
import Filters from '@/components/Filters';

export default {

  name: 'aansluitingen',
  components: { Operator, Filters },
  data() {
    return {
      startDate: new Date().toISOString().substr(0, 10),
      menu1: false,
      endDate: new Date().toISOString().substr(0, 10),
      menu2: false,
      addDialog: false,
      startHour: '',
      endHour: '',
      dialog: false,
      impacts: [
        { text: 'Hoog', value: 2 },
        { text: 'Laag', value: 1 },
      ],
      impact: {value: 0},
      selectedOperators: [],
      errors:[],
      headers: [
        { text: 'Start onderhoud', value: 'start', align: 'left',},
        { text: 'Eind onderhoud', value: 'end', align: 'left',},
        { text: 'Netbeheerder(s)', value: 'operators', align: 'left', sortable:false},
        { text: 'Verwachte impact', value: 'impact', align: 'left',},

      ],
      maintenanceFilterOptions:
      {
        impact:{type:'select', label:'Verwachte impact', options:this.impacts},
        start:{type:'date', label:'Start onderhoud'},
        end:{type:'date', label:'Eind onderhoud'},
      },
      maintenances: [
      ],
      snackbar: false,
      text: 'Succesvol opgeslagen',
      color: 'primary',
	   snackbar_icon:'check_circle',
	   icon:'check_circle',
      timeout: 3000,
      maintenanceFilter: false,
      maintenancesLoading: true,
      maintenancesTotal:0,
      pageContent: {
        pageTitle: 'Onderhoud voor de komende 30 dagen',
        pageSub1: 'Alle aansluitingen',
        pageSub2: 'Onderhoud',
      },

    };
  },
  methods:{
    
    storeMaintenance()
    {
      let data = 
      {
        start_date: this.startDate,
        start_hour: this.startHour,
        end_date: this.endDate,
        end_hour: this.endHour,
        impact: this.impact,
      };
      data.operators = [];
      for(let i in this.selectedOperators)
      {
        if(this.selectedOperators[i].value == null)
        {
          data.operators = [];
          for(let j in this.$store.state.operators)
          {
            if(this.$store.state.operators[j].value == null)
            {
              continue;
            }
            data.operators.push(this.$store.state.operators[j].value);
          }
          break;
        }
        data.operators.push(this.selectedOperators[i].value);
      }
      this.$store.dispatch('addMaintenance', data).then
      ((data) => {
        this.startHour = '';
        this.endHour = '';
        this.impact = 0;
        this.selectedOperators = [];
        this.text = 'Succesvol opgeslagen';
        this.color = 'primary';
        this.snackbar_icon = 'check_circle'
        this.snackbar = true;
        this.addDialog = false;
        this.maintenanceOptions.page = 1;
        this.loadMaintenances();
      }).catch(
      (errors) => {
        this.errors = errors.errors;
      });
    },
	  toggle () {
      this.$nextTick(() => {
        if (this.allOperators) {
        this.selectedOperators = []
        } else {
        this.selectedOperators = this.operators.slice()
        }
      })
    },
    loadMaintenances(){
      
      this.maintenancesLoading = true;
      this.$store.dispatch('LoadMaintenance', this.maintenanceOptions).then
      ((data) => {
        this.maintenancesTotal = data.recordsTotal;
        this.maintenances = data.data;
        this.maintenancesLoading = false;
      });
    },
    filter(filters)
    {
      let temp = JSON.parse(JSON.stringify(this.maintenanceOptions));
      temp.filters = filters;
      temp.page = 1;
      this.maintenanceOptions = JSON.parse(JSON.stringify(temp));
    },
  },
  computed: {
    maintenanceOptions: {
        get: function()
        {
          return this.$store.state.maintenanceOptions;
        },
        set: function(value)
        {
          this.$store.state.maintenanceOptions = value;
        }
    },
    permissions : {
      get() {
        return this.$store.getters.permissions;
      }
    }
  },
  watch:
  {
    maintenanceOptions: {
      deep:true,
          handler (newState, old) {
           this.loadMaintenances();
      }
    }
	},

};

</script>

<style scoped>

.v-card.energy-dates {
    -moz-transition: all 200ms ease-in;
    -webkit-transition: all 200ms ease-in;
    -o-transition: all 200ms ease-in;
    transition: all 200ms ease-in;
}

.v-card.energy-dates:not(.on-hover):not(.v-item--active){
  background: #141414;
 }

.v-card.v-card--link:before{
  background: none;
}

.show-btns {
  color: rgba(255, 255, 255, 1) !important;
}
</style>